import React, {
  useState,
  useRef,
  memo,
  forwardRef,
  useEffect,
  useImperativeHandle,
} from 'react';
import {
  ContentState,
  EditorState,
  convertToRaw,
  convertFromHTML,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import Editor from '@components/richEditor/richEditor';
import decorator from '@components/richEditor/decorator';
import { RICH_TYPE } from '@components/richEditor/configs';

const getContentSource = (value) => {
  if (typeof value === 'object') {
    return value;
  }
  const blocksFromHTML = convertFromHTML(value || '');
  const content = ContentState.createFromBlockArray(
    blocksFromHTML.contentBlocks,
    blocksFromHTML.entityMap,
  );
  const state = EditorState.createWithContent(content, decorator);
  return convertToRaw(state.getCurrentContent());
};

const AgRichEditor = memo(
  forwardRef((props, ref) => {
    const [value, setValue] = useState(null);
    const [initialContentChange, setInitialContentChange] = useState(0);
    const refInput = useRef(null);
    useEffect(() => {
      refInput.current.focus();
    }, []);

    useEffect(() => {
      setValue(getContentSource(props.value));
      setInitialContentChange((v) => v + 1);
    }, [props.value]);

    useImperativeHandle(ref, () => ({
      getValue() {
        const htmlString = draftToHtml(value);
        return htmlString;
      },
    }));

    return (
      <div style={{ padding: 10, paddingRight: 0 }}>
        <Editor
          ref={refInput}
          contentSource={value}
          richTypes={[
            RICH_TYPE.UNDERLINE,
            RICH_TYPE.ITALIC,
            RICH_TYPE.BOLD,
            RICH_TYPE.UNORDERED_LIST,
            RICH_TYPE.ORDERED_LIST,
            RICH_TYPE.LINK,
          ]}
          onChange={setValue}
          onInitialContentChange={initialContentChange}
        />
      </div>
    );
  }),
);

export default AgRichEditor;
